import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Popover from "@mui/material/Popover";
import { useSelector, useDispatch } from "react-redux";
import Select from "../Views/Select";
import { NavDropdown, Nav, Item } from "react-bootstrap";
import CustomDrawer from "../Views/CustomDrawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "antd/lib/avatar/avatar";
import stc from "string-to-color";
import { actionGetUser } from "../../redux/actions/UserAction";
import { Cog } from "lucide-react";
import { actionChangeDefaultCompany } from "../../redux/actions/companyAction";

let theme = "1";
const data = localStorage.getItem("theme");

if (data) {
  theme = JSON.parse(data).theme;
}

export default function Header() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [openDrawer, setOpen] = useState(false);
  const [largeur, setLargeur] = useState(window.innerWidth);
  const [anchorEl, setAnchorEl] = useState(null);

  const token = useSelector((state) => state.user.token);
  const idUser = useSelector((state) => state.user.id);
  const defaultCompany = useSelector((state) => state.user.idcompany);
  // const roleCompany = useSelector((state) => state.user.role);

  const user = useSelector((state) => state.user);
  const selectedWorkspace = useSelector(
    (state) => state.user.selectedWorkspace
  );
  const companies = useSelector((state) => state.companies.companies);

  const defaultLink = useSelector((state) => state.user.defaultLink);
  const location = useLocation();
  // const firstname = useSelector((state) => data.user.firstName);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  window.onresize = () => {
    // console.log("window.innerHeight", window.innerHeight);
    // console.log("window.innerWidth", window.innerWidth);
    setLargeur(window.innerWidth);
  };

  const open = Boolean(anchorEl);
  const id = open ? `simple-popover-header` : undefined;

  useEffect(() => {
    dispatch(actionGetUser(idUser, token));
  }, []);

  const adjustColorIfCloseToWhite = (
    hex,
    threshold = 200,
    blendFactor = 0.3
  ) => {
    const num = parseInt(hex.slice(1), 16);
    const [r, g, b] = [(num >> 16) & 255, (num >> 8) & 255, num & 255];
    const distanceToWhite = Math.sqrt(
      (255 - r) ** 2 + (255 - g) ** 2 + (255 - b) ** 2
    );

    if (distanceToWhite < threshold) {
      return `#${[r, g, b]
        .map((c) =>
          Math.round(c * (1 - blendFactor))
            .toString(16)
            .padStart(2, "0")
        )
        .join("")}`;
    }

    return hex;
  };

  const changeCompany = (idcompany) => {
    dispatch(
      actionChangeDefaultCompany(
        idcompany,
        idUser,
        token,
        ({ status, data }) => {
          if (status) {
            // localStorage.setItem("idworkspace", null);
            window.location.reload();
          }
        }
      )
    );
  };

  return (
    <>
      {largeur < 900 ? (
        <CustomDrawer open={openDrawer} onClose={() => setOpen(false)}>
          <List>
            <ListItem
              button
              key={"dashboard"}
              onClick={() => {
                setOpen(false);
                navigate("/home");
              }}
            >
              <ListItemText primary={"Dashboard"} />
            </ListItem>
            <ListItem
              button
              key={"datasources"}
              onClick={() => {
                setOpen(false);
                navigate("/datasources");
              }}
            >
              <ListItemText primary={"Datasets"} />
            </ListItem>

            <ListItem
              button
              key={"Colonnes"}
              onClick={() => {
                setOpen(false);
                navigate("/colonnes");
              }}
            >
              <ListItemText primary={"Colonnes"} />
            </ListItem>

            <ListItem
              button
              key={"goals"}
              onClick={() => {
                setOpen(false);
                navigate("/goals");
              }}
            >
              <ListItemText primary={"Objectifs"} />
            </ListItem>

            <ListItem
              button
              key={"rapport"}
              onClick={() => {
                setOpen(false);
                navigate("/rapport");
              }}
            >
              <ListItemText primary={"Rapports"} />
            </ListItem>
            <ListItem
              button
              key={"equipes"}
              onClick={() => {
                setOpen(false);
                navigate("/equipes");
              }}
            >
              <ListItemText primary={"Equipes"} />
            </ListItem>
            <ListItem
              button
              key={"primes"}
              onClick={() => {
                setOpen(false);
                navigate("/primes");
              }}
            >
              <ListItemText primary={"Primes"} />
            </ListItem>

            {/* <ListItem button key={"theme"}>
          <ListItemText primary={"Theme"} />
        </ListItem> */}
          </List>
          <Nav>
            <NavDropdown title="Thème" id="basic-nav-dropdown">
              <NavDropdown.Item
                href="#action/3.1"
                onClick={() => {
                  localStorage.setItem("theme", JSON.stringify({ theme: "0" }));
                  window.location.reload();
                }}
              >
                Dark
              </NavDropdown.Item>
              <NavDropdown.Item
                href="#action/3.2"
                onClick={() => {
                  localStorage.setItem("theme", JSON.stringify({ theme: "1" }));
                  window.location.reload();
                }}
              >
                Light
              </NavDropdown.Item>
              <NavDropdown.Item
                href="#action/3.2"
                onClick={() => {
                  localStorage.setItem("theme", JSON.stringify({ theme: "2" }));
                  window.location.reload();
                }}
              >
                {/* Blue */}
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </CustomDrawer>
      ) : null}

      <header
        id="viabber-header"
        className="fixed top-0 left-0 right-0 z-50 bg-gray-400/15 backdrop-blur-md "
      >
        <div className="container-fluid">
          <div className="row ">
            <div
              className="flex items-centerjustify-evenly col-12 header-block"
              style={{
                ...(largeur > 900 ? {} : { justifyContent: "space-between" }),
              }}
            >
              {/*largeur < 900 ? (
                <i
                  className="fa-solid fa-bars"
                  style={{
                    marginRight: "10px",
                    fontSize: "17px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpen(true);
                  }}
                ></i>
              ) : null*/}

              <a className="logo">
                <img
                  src={
                    theme === "0"
                      ? "./viabber-logo.svg"
                      : theme === "1"
                      ? "./logo-viabber3.svg"
                      : "./logo-blue.png"
                  }
                  alt=""
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (idUser) {
                      navigate(defaultLink ? `/${defaultLink}` : "/home");
                    } else {
                      navigate("/home");
                    }
                  }}
                />
              </a>
              {/* {largeur > 900 ? ( */}
              <nav
                className="justify-end mr-4 header-block-nav"
                style={{ flexDirection: idUser ? "" : "row-reverse" }}
              >
                <ul className="flex ">
                  {idUser && selectedWorkspace ? (
                    <>
                      <li
                        className={
                          location.pathname === "/home" ||
                          location.pathname === "/board"
                            ? "header-block-nav-li active"
                            : "header-block-nav-li"
                        }
                      >
                        <Link to="/home" title="Dashboard" target="_self">
                          <a href="#" title="Datasets" target="_self">
                            <svg
                              width="18"
                              height="16"
                              viewBox="0 0 18 18"
                              fill={
                                location.pathname === "/home" ||
                                location.pathname === "/board"
                                  ? "#FFFFFF"
                                  : "#54555E"
                              }
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M0.104248 17.8541V16.2916H19.8959V17.8541H0.104248ZM1.14591 14.8491V8.47908H3.75008V14.8491H1.14591ZM6.17404 14.8491V3.27075H8.77821V14.8491H6.17404ZM11.2121 14.8491V6.39575H13.8162V14.8491H11.2121ZM16.2501 14.8491V0.145752H18.8543V14.8491H16.2501Z" />
                            </svg>
                            Dashboard
                          </a>
                        </Link>
                      </li>

                      <li
                        className={
                          location.pathname === "/datasources"
                            ? "header-block-nav-li active"
                            : "header-block-nav-li"
                        }
                      >
                        <Link to="/datasources" title="Datasets" target="_self">
                          <a href="#" title="Datasets" target="_self">
                            <svg
                              width="23"
                              height="23"
                              viewBox="0 0 23 23"
                              fill={
                                location.pathname === "/datasources"
                                  ? "#FFFFFF"
                                  : "#54555E"
                              }
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M8.052 17.9478H11.6978V14.302H8.052V17.9478ZM14.302 17.9478H17.9478V14.302H14.302V17.9478ZM8.052 11.6978H11.6978V8.052H8.052V11.6978ZM14.302 11.6978H17.9478V8.052H14.302V11.6978ZM6.02882 21.8541C5.50261 21.8541 5.05721 21.6718 4.69263 21.3072C4.32804 20.9426 4.14575 20.4972 4.14575 19.971V6.02882C4.14575 5.50261 4.32804 5.05721 4.69263 4.69263C5.05721 4.32804 5.50261 4.14575 6.02882 4.14575H19.971C20.4972 4.14575 20.9426 4.32804 21.3072 4.69263C21.6718 5.05721 21.8541 5.50261 21.8541 6.02882V19.971C21.8541 20.4972 21.6718 20.9426 21.3072 21.3072C20.9426 21.6718 20.4972 21.8541 19.971 21.8541H6.02882ZM6.02882 20.2916H19.971C20.0512 20.2916 20.1247 20.2582 20.1913 20.1913C20.2582 20.1247 20.2916 20.0512 20.2916 19.971V6.02882C20.2916 5.94862 20.2582 5.87518 20.1913 5.80851C20.1247 5.74167 20.0512 5.70825 19.971 5.70825H6.02882C5.94862 5.70825 5.87518 5.74167 5.80851 5.80851C5.74167 5.87518 5.70825 5.94862 5.70825 6.02882V19.971C5.70825 20.0512 5.74167 20.1247 5.80851 20.1913C5.87518 20.2582 5.94862 20.2916 6.02882 20.2916Z" />
                            </svg>
                            Datasets
                          </a>
                        </Link>
                      </li>
                      {/* <li
                        className={
                          location.pathname === "/indicators"
                            ? "header-block-nav-li active"
                            : "header-block-nav-li"
                        }
                      >
                        <Link to="/indicators" title="Datasets" target="_self">
                          <a href="#" title="Datasets" target="_self">
                            <svg
                              width="23"
                              height="23"
                              viewBox="0 0 23 23"
                              fill={
                                location.pathname === "/indicators"
                                  ? "#FFFFFF"
                                  : "#54555E"
                              }
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M8.052 17.9478H11.6978V14.302H8.052V17.9478ZM14.302 17.9478H17.9478V14.302H14.302V17.9478ZM8.052 11.6978H11.6978V8.052H8.052V11.6978ZM14.302 11.6978H17.9478V8.052H14.302V11.6978ZM6.02882 21.8541C5.50261 21.8541 5.05721 21.6718 4.69263 21.3072C4.32804 20.9426 4.14575 20.4972 4.14575 19.971V6.02882C4.14575 5.50261 4.32804 5.05721 4.69263 4.69263C5.05721 4.32804 5.50261 4.14575 6.02882 4.14575H19.971C20.4972 4.14575 20.9426 4.32804 21.3072 4.69263C21.6718 5.05721 21.8541 5.50261 21.8541 6.02882V19.971C21.8541 20.4972 21.6718 20.9426 21.3072 21.3072C20.9426 21.6718 20.4972 21.8541 19.971 21.8541H6.02882ZM6.02882 20.2916H19.971C20.0512 20.2916 20.1247 20.2582 20.1913 20.1913C20.2582 20.1247 20.2916 20.0512 20.2916 19.971V6.02882C20.2916 5.94862 20.2582 5.87518 20.1913 5.80851C20.1247 5.74167 20.0512 5.70825 19.971 5.70825H6.02882C5.94862 5.70825 5.87518 5.74167 5.80851 5.80851C5.74167 5.87518 5.70825 5.94862 5.70825 6.02882V19.971C5.70825 20.0512 5.74167 20.1247 5.80851 20.1913C5.87518 20.2582 5.94862 20.2916 6.02882 20.2916Z" />
                            </svg>
                            Indicateurs
                          </a>
                        </Link>
                      </li> */}
                      {/* <li
                        className={
                          location.pathname === "/colonnes"
                            ? "header-block-nav-li active"
                            : "header-block-nav-li"
                        }
                      >
                        <Link to="/colonnes" title="Colonnes" target="_self">
                          <a
                            href="#"
                            title="Connecteurs"
                            target="_self"
                            className="text-red-900"
                          >
                            <svg
                              width="23"
                              height="22"
                              viewBox="0 0 23 22"
                              xmlns="http://www.w3.org/2000/svg"
                              fill={
                                location.pathname === "/colonnes"
                                  ? "#FFFFFF"
                                  : "#54555E"
                              }
                            >
                              <path d="M4.80775 18H8.8365V6H4.80775C4.71792 6 4.64417 6.02883 4.5865 6.0865C4.52883 6.14417 4.5 6.21792 4.5 6.30775V17.6923C4.5 17.7821 4.52883 17.8558 4.5865 17.9135C4.64417 17.9712 4.71792 18 4.80775 18ZM10.3365 18H14.6635V6H10.3365V18ZM16.1635 18H20.1923C20.2821 18 20.3558 17.9712 20.4135 17.9135C20.4712 17.8558 20.5 17.7821 20.5 17.6923V6.30775C20.5 6.21792 20.4712 6.14417 20.4135 6.0865C20.3558 6.02883 20.2821 6 20.1923 6H16.1635V18ZM4.80775 19.5C4.30258 19.5 3.875 19.325 3.525 18.975C3.175 18.625 3 18.1974 3 17.6923V6.30775C3 5.80258 3.175 5.375 3.525 5.025C3.875 4.675 4.30258 4.5 4.80775 4.5H20.1923C20.6974 4.5 21.125 4.675 21.475 5.025C21.825 5.375 22 5.80258 22 6.30775V17.6923C22 18.1974 21.825 18.625 21.475 18.975C21.125 19.325 20.6974 19.5 20.1923 19.5H4.80775Z" />
                            </svg>
                            Colonnes
                          </a>
                        </Link>
                      </li> */}
                      {/* <li
                        className={
                          location.pathname === "/equipes"
                            ? "header-block-nav-li active"
                            : "header-block-nav-li"
                        }
                      >
                        <Link to="/equipes" title="equipes" target="_self">
                          <a
                            href="#"
                            title="Connecteurs"
                            target="_self"
                            className="text-red-900"
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill={
                                location.pathname === "/equipes"
                                  ? "#FFFFFF"
                                  : "#54555E"
                              }
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M0.5 17.7886V16.5694C0.5 15.904 0.847417 15.3575 1.54225 14.9299C2.23725 14.5024 3.14308 14.2886 4.25975 14.2886C4.44425 14.2886 4.63008 14.2944 4.81725 14.3059C5.00442 14.3174 5.19292 14.3398 5.38275 14.3731C5.18792 14.6848 5.04333 15.0082 4.949 15.3434C4.85483 15.6787 4.80775 16.0226 4.80775 16.3751V17.7886H0.5ZM6.5 17.7886V16.4136C6.5 15.9454 6.63142 15.5175 6.89425 15.1299C7.15708 14.742 7.53592 14.4039 8.03075 14.1156C8.52558 13.8271 9.11025 13.6108 9.78475 13.4666C10.4591 13.3223 11.1962 13.2501 11.9963 13.2501C12.8116 13.2501 13.5564 13.3223 14.2308 13.4666C14.9051 13.6108 15.4897 13.8271 15.9845 14.1156C16.4795 14.4039 16.8558 14.742 17.1135 15.1299C17.3712 15.5175 17.5 15.9454 17.5 16.4136V17.7886H6.5ZM19.1923 17.7886V16.3781C19.1923 16.0019 19.1477 15.6474 19.0588 15.3146C18.9696 14.9819 18.8359 14.6681 18.6578 14.3731C18.8539 14.3398 19.0414 14.3174 19.2203 14.3059C19.3991 14.2944 19.5757 14.2886 19.75 14.2886C20.8667 14.2886 21.7708 14.4999 22.4625 14.9224C23.1542 15.3447 23.5 15.8937 23.5 16.5694V17.7886H19.1923ZM8.077 16.2886H15.9385V16.1829C15.836 15.779 15.4103 15.4393 14.6615 15.1636C13.9128 14.8879 13.0257 14.7501 12 14.7501C10.9743 14.7501 10.0872 14.8879 9.3385 15.1636C8.58967 15.4393 8.16917 15.779 8.077 16.1829V16.2886ZM4.257 13.3174C3.78567 13.3174 3.383 13.1498 3.049 12.8146C2.715 12.4794 2.548 12.0765 2.548 11.6059C2.548 11.129 2.71567 10.7262 3.051 10.3974C3.38617 10.0685 3.78908 9.90411 4.25975 9.90411C4.73658 9.90411 5.141 10.0685 5.473 10.3974C5.80517 10.7262 5.97125 11.13 5.97125 11.6089C5.97125 12.0735 5.80692 12.4744 5.47825 12.8116C5.14975 13.1488 4.74267 13.3174 4.257 13.3174ZM19.75 13.3174C19.2833 13.3174 18.8814 13.1488 18.5443 12.8116C18.2071 12.4744 18.0385 12.0735 18.0385 11.6089C18.0385 11.13 18.2071 10.7262 18.5443 10.3974C18.8814 10.0685 19.2839 9.90411 19.7518 9.90411C20.2339 9.90411 20.6394 10.0685 20.9683 10.3974C21.2971 10.7262 21.4615 11.129 21.4615 11.6059C21.4615 12.0765 21.2975 12.4794 20.9695 12.8146C20.6415 13.1498 20.235 13.3174 19.75 13.3174ZM12.0035 12.5001C11.2832 12.5001 10.6698 12.2477 10.1635 11.7429C9.65717 11.2382 9.404 10.6253 9.404 9.90411C9.404 9.16844 9.65633 8.55186 10.161 8.05436C10.6658 7.55669 11.2788 7.30786 12 7.30786C12.7355 7.30786 13.3521 7.55636 13.8497 8.05336C14.3472 8.55019 14.596 9.16595 14.596 9.90061C14.596 10.6208 14.3476 11.2341 13.8508 11.7406C13.3538 12.2469 12.738 12.5001 12.0035 12.5001ZM12.0048 11.0001C12.3106 11.0001 12.5689 10.8931 12.7797 10.6791C12.9908 10.4649 13.0962 10.2049 13.0962 9.89911C13.0962 9.59345 12.9912 9.33511 12.781 9.12411C12.5708 8.91328 12.3105 8.80786 12 8.80786C11.6975 8.80786 11.4392 8.91294 11.225 9.12311C11.0108 9.33311 10.9038 9.59344 10.9038 9.90411C10.9038 10.2066 11.0108 10.4649 11.225 10.6791C11.4392 10.8931 11.6991 11.0001 12.0048 11.0001Z" />
                            </svg>
                            Equipes
                          </a>
                        </Link>
                      </li> */}
                      {/* <li
                        className={
                          location.pathname === "/periode"
                            ? "header-block-nav-li active"
                            : "header-block-nav-li"
                        }
                      >
                        <Link to="/periode" title="periode" target="_self">
                          <a
                            href="#"
                            title="periode"
                            target="_self"
                            className="text-red-900"
                          >
                            <svg
                              width="23"
                              height="22"
                              viewBox="0 0 23 22"
                              xmlns="http://www.w3.org/2000/svg"
                              fill={
                                location.pathname === "/periode"
                                  ? "#FFFFFF"
                                  : "#54555E"
                              }
                            >
                              <path d="M2.30775 19.5C1.80258 19.5 1.375 19.325 1.025 18.975C0.675 18.625 0.5 18.1974 0.5 17.6923V4.30777C0.5 3.8026 0.675 3.37502 1.025 3.02502C1.375 2.67502 1.80258 2.50002 2.30775 2.50002H3.69225V0.384766H5.23075V2.50002H12.8077V0.384766H14.3077V2.50002H15.6923C16.1974 2.50002 16.625 2.67502 16.975 3.02502C17.325 3.37502 17.5 3.8026 17.5 4.30777V17.6923C17.5 18.1974 17.325 18.625 16.975 18.975C16.625 19.325 16.1974 19.5 15.6923 19.5H2.30775ZM2.30775 18H15.6923C15.7692 18 15.8398 17.9679 15.9038 17.9038C15.9679 17.8398 16 17.7693 16 17.6923V8.30777H2V17.6923C2 17.7693 2.03208 17.8398 2.09625 17.9038C2.16025 17.9679 2.23075 18 2.30775 18ZM2 6.80777H16V4.30777C16 4.23077 15.9679 4.16026 15.9038 4.09626C15.8398 4.0321 15.7692 4.00002 15.6923 4.00002H2.30775C2.23075 4.00002 2.16025 4.0321 2.09625 4.09626C2.03208 4.16026 2 4.23077 2 4.30777V6.80777ZM9 12.077C8.75517 12.077 8.5465 11.9908 8.374 11.8183C8.20167 11.6459 8.1155 11.4373 8.1155 11.1923C8.1155 10.9474 8.20167 10.7388 8.374 10.5663C8.5465 10.3939 8.75517 10.3078 9 10.3078C9.24483 10.3078 9.4535 10.3939 9.626 10.5663C9.79833 10.7388 9.8845 10.9474 9.8845 11.1923C9.8845 11.4373 9.79833 11.6459 9.626 11.8183C9.4535 11.9908 9.24483 12.077 9 12.077ZM5 12.077C4.75517 12.077 4.5465 11.9908 4.374 11.8183C4.20167 11.6459 4.1155 11.4373 4.1155 11.1923C4.1155 10.9474 4.20167 10.7388 4.374 10.5663C4.5465 10.3939 4.75517 10.3078 5 10.3078C5.24483 10.3078 5.4535 10.3939 5.626 10.5663C5.79833 10.7388 5.8845 10.9474 5.8845 11.1923C5.8845 11.4373 5.79833 11.6459 5.626 11.8183C5.4535 11.9908 5.24483 12.077 5 12.077ZM13 12.077C12.7552 12.077 12.5465 11.9908 12.374 11.8183C12.2017 11.6459 12.1155 11.4373 12.1155 11.1923C12.1155 10.9474 12.2017 10.7388 12.374 10.5663C12.5465 10.3939 12.7552 10.3078 13 10.3078C13.2448 10.3078 13.4535 10.3939 13.626 10.5663C13.7983 10.7388 13.8845 10.9474 13.8845 11.1923C13.8845 11.4373 13.7983 11.6459 13.626 11.8183C13.4535 11.9908 13.2448 12.077 13 12.077ZM9 16C8.75517 16 8.5465 15.9138 8.374 15.7413C8.20167 15.5689 8.1155 15.3603 8.1155 15.1155C8.1155 14.8705 8.20167 14.6618 8.374 14.4895C8.5465 14.317 8.75517 14.2308 9 14.2308C9.24483 14.2308 9.4535 14.317 9.626 14.4895C9.79833 14.6618 9.8845 14.8705 9.8845 15.1155C9.8845 15.3603 9.79833 15.5689 9.626 15.7413C9.4535 15.9138 9.24483 16 9 16ZM5 16C4.75517 16 4.5465 15.9138 4.374 15.7413C4.20167 15.5689 4.1155 15.3603 4.1155 15.1155C4.1155 14.8705 4.20167 14.6618 4.374 14.4895C4.5465 14.317 4.75517 14.2308 5 14.2308C5.24483 14.2308 5.4535 14.317 5.626 14.4895C5.79833 14.6618 5.8845 14.8705 5.8845 15.1155C5.8845 15.3603 5.79833 15.5689 5.626 15.7413C5.4535 15.9138 5.24483 16 5 16ZM13 16C12.7552 16 12.5465 15.9138 12.374 15.7413C12.2017 15.5689 12.1155 15.3603 12.1155 15.1155C12.1155 14.8705 12.2017 14.6618 12.374 14.4895C12.5465 14.317 12.7552 14.2308 13 14.2308C13.2448 14.2308 13.4535 14.317 13.626 14.4895C13.7983 14.6618 13.8845 14.8705 13.8845 15.1155C13.8845 15.3603 13.7983 15.5689 13.626 15.7413C13.4535 15.9138 13.2448 16 13 16Z" />
                            </svg>
                            Periode
                          </a>
                        </Link>
                      </li> */}
                      {/* <li
                        className={
                          location.pathname === "/conditions"
                            ? "header-block-nav-li active"
                            : "header-block-nav-li"
                        }
                      >
                        <Link to="/conditions" title="Colonnes" target="_self">
                          <a
                            href="#"
                            title="Connecteurs"
                            target="_self"
                            className="text-red-900"
                          >
                            <svg
                              width="23"
                              height="22"
                              viewBox="0 0 23 22"
                              xmlns="http://www.w3.org/2000/svg"
                              fill={
                                location.pathname === "/conditions"
                                  ? "#FFFFFF"
                                  : "#54555E"
                              }
                            >
                              <path d="M4.80775 18H8.8365V6H4.80775C4.71792 6 4.64417 6.02883 4.5865 6.0865C4.52883 6.14417 4.5 6.21792 4.5 6.30775V17.6923C4.5 17.7821 4.52883 17.8558 4.5865 17.9135C4.64417 17.9712 4.71792 18 4.80775 18ZM10.3365 18H14.6635V6H10.3365V18ZM16.1635 18H20.1923C20.2821 18 20.3558 17.9712 20.4135 17.9135C20.4712 17.8558 20.5 17.7821 20.5 17.6923V6.30775C20.5 6.21792 20.4712 6.14417 20.4135 6.0865C20.3558 6.02883 20.2821 6 20.1923 6H16.1635V18ZM4.80775 19.5C4.30258 19.5 3.875 19.325 3.525 18.975C3.175 18.625 3 18.1974 3 17.6923V6.30775C3 5.80258 3.175 5.375 3.525 5.025C3.875 4.675 4.30258 4.5 4.80775 4.5H20.1923C20.6974 4.5 21.125 4.675 21.475 5.025C21.825 5.375 22 5.80258 22 6.30775V17.6923C22 18.1974 21.825 18.625 21.475 18.975C21.125 19.325 20.6974 19.5 20.1923 19.5H4.80775Z" />
                            </svg>
                            Conditions
                          </a>
                        </Link>
                      </li> */}
                      {/* <li
                        className={
                          location.pathname === "/primes"
                            ? "header-block-nav-li active"
                            : "header-block-nav-li"
                        }
                      >
                        <Link to="/primes" title="Primes" target="_self">
                          <a href="#" title="Primes" target="_self">
                            <svg
                              width="23"
                              height="23"
                              viewBox="0 0 23 23"
                              fill={
                                location.pathname === "/primes"
                                  ? "#FFFFFF"
                                  : "#54555E"
                              }
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M4.78706 22.8958V11.5575H3.10425V6.12913H8.49097C8.34409 5.95952 8.24427 5.76846 8.19149 5.55596C8.13871 5.34363 8.11232 5.12063 8.11232 4.88695C8.11232 4.10795 8.38498 3.4458 8.93029 2.90049C9.4756 2.35518 10.1378 2.08252 10.9167 2.08252C11.3161 2.08252 11.686 2.16629 12.0266 2.33382C12.3671 2.50153 12.6715 2.72557 12.9399 3.00596C13.2083 2.71481 13.5128 2.48816 13.8535 2.32601C14.1939 2.16368 14.5638 2.08252 14.9631 2.08252C15.7423 2.08252 16.4045 2.35518 16.9498 2.90049C17.4951 3.4458 17.7678 4.10795 17.7678 4.88695C17.7678 5.11802 17.7387 5.33773 17.6806 5.54606C17.6224 5.75439 17.5253 5.94875 17.3891 6.12913H22.8959V11.5575H21.2131V22.8958H4.78706ZM14.9631 3.64502C14.6112 3.64502 14.3162 3.76403 14.0782 4.00205C13.8402 4.24007 13.7212 4.53504 13.7212 4.88695C13.7212 5.23886 13.8402 5.53382 14.0782 5.77184C14.3162 6.01004 14.6112 6.12913 14.9631 6.12913C15.315 6.12913 15.6101 6.01004 15.8483 5.77184C16.0863 5.53382 16.2053 5.23886 16.2053 4.88695C16.2053 4.53504 16.0863 4.24007 15.8483 4.00205C15.6101 3.76403 15.315 3.64502 14.9631 3.64502ZM9.67482 4.88695C9.67482 5.23886 9.79383 5.53382 10.0319 5.77184C10.2699 6.01004 10.5648 6.12913 10.9167 6.12913C11.2687 6.12913 11.5636 6.01004 11.8016 5.77184C12.0397 5.53382 12.1587 5.23886 12.1587 4.88695C12.1587 4.53504 12.0397 4.24007 11.8016 4.00205C11.5636 3.76403 11.2687 3.64502 10.9167 3.64502C10.5648 3.64502 10.2699 3.76403 10.0319 4.00205C9.79383 4.24007 9.67482 4.53504 9.67482 4.88695ZM4.66675 7.69137V9.99528H12.2188V7.69137H4.66675ZM12.2188 21.3333V11.5575H6.3493V21.3333H12.2188ZM13.7813 21.3333H19.6509V11.5575H13.7813V21.3333ZM21.3334 9.99528V7.69137H13.7813V9.99528H21.3334Z" />
                            </svg>
                            Primes
                          </a>
                        </Link>
                      </li> */}
                    </>
                  ) : null}
                </ul>
              </nav>
              {/* ) : null} */}

              <div className="header-block-wrap">
                {idUser ? (
                  <>
                    <div
                      className="profil blackprofile lightprofile"
                      onClick={handleClick}
                      aria-describedby={id}
                      title={user.email}
                    >
                      <div className="cursor-pointer profil-picture">
                        <div
                          className="flex items-center justify-center w-10 h-10 text-lg font-semibold text-white rounded-full select-none"
                          style={{
                            backgroundColor: "#04B6EE",
                          }}
                        >
                          {user
                            ? user?.firstName?.substr(0, 1) +
                              "" +
                              user?.lastName?.substr(0, 1)
                            : null}
                        </div>
                      </div>
                    </div>
                    <Popover
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      className="mt-2 mr-2 p-[20px]"
                    >
                      <div className="w-[227px] items-center justify-start flex-col flex py-2 px-3 font-poppins">
                        {/* user ingfo */}
                        <div className="flex justify-start w-full gap-2 py-2 border-b ">
                          <div
                            className="flex items-center justify-center text-lg font-semibold text-white rounded-full select-none w-9 h-9"
                            style={{
                              backgroundColor: "#04B6EE",
                            }}
                          >
                            {user
                              ? user?.firstName?.substr(0, 1) +
                                "" +
                                user?.lastName?.substr(0, 1)
                              : null}
                          </div>
                          <div className="flex flex-col items-start justify-center gap-0">
                            <p className="p-0 m-0 text-[14px] font-poppins font-[500]">
                              {user?.firstName + " " + user?.lastName}
                            </p>
                            <p className="p-0 m-0 text-[11px] text-gray-500">
                              {user?.email}
                            </p>
                          </div>
                        </div>
                        <div className="flex flex-col w-full py-1 font-poppins">
                          <h4 className="text-[10px] text-gray-500">
                            Entreprise
                          </h4>
                          {companies.map((company, index) => (
                            <div
                              className={`flex items-center justify-start gap-1 my-2 space-x-2 pr-1 cursor-pointer ${
                                +company.id === +defaultCompany
                                  ? "border-r-4 border-colorText"
                                  : ""
                              } `}
                              key={index}
                              onClick={() => {
                                changeCompany(+company.id);
                              }}
                            >
                              <span className="flex items-center justify-center w-6 h-6 text-sm font-semibold text-white bg-colorText rounded-[3px]">
                                {company?.name[0]?.toUpperCase()}
                              </span>
                              <p className="text-[12px] m-0 p-0 font-[500]">
                                {company?.name}
                              </p>
                            </div>
                          ))}
                          <p
                            className="text-[11px] text-black cursor-pointer m-0 p-0"
                            onClick={() => navigate("/workspaces")}
                          >
                            Afficher tous les workspaces
                          </p>
                        </div>

                        {/* Espaces de travail récents */}
                        {/* <div className="flex flex-col w-full py-1 font-poppins">
                          <h4 className="text-[10px] text-gray-500">
                            Espace de travail récent
                          </h4>

                          <div className="flex items-center gap-1 mb-2 space-x-2">
                            <span className="flex items-center justify-center w-6 h-6 text-sm font-semibold text-white bg-red-500 rounded-[3px]">
                              W
                            </span>
                            <p className="text-[12px] m-0 p-0 font-[500]">
                              Workspace 2
                            </p>
                          </div>
                          <div className="flex items-center gap-1 mb-2 space-x-2">
                            <span className="flex items-center justify-center w-6 h-6 text-sm font-semibold text-white bg-blue-500 rounded-[3px]">
                              G
                            </span>
                            <p className="text-[12px] m-0 p-0 font-[500]">
                              Ginov 2
                            </p>
                          </div>
                        </div> */}

                        {/* Options */}
                        <div className="w-full border-t ">
                          <ul className="py-1 m-0 space-y-2 border-light-blue-900">
                            {/* <li className="flex items-center gap-2 space-x-2 font-semibold cursor-pointer font-poppins">
                              <svg
                                width="19"
                                height="19"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M0.5 17.7886V16.5694C0.5 15.904 0.847417 15.3575 1.54225 14.9299C2.23725 14.5024 3.14308 14.2886 4.25975 14.2886C4.44425 14.2886 4.63008 14.2944 4.81725 14.3059C5.00442 14.3174 5.19292 14.3398 5.38275 14.3731C5.18792 14.6848 5.04333 15.0082 4.949 15.3434C4.85483 15.6787 4.80775 16.0226 4.80775 16.3751V17.7886H0.5ZM6.5 17.7886V16.4136C6.5 15.9454 6.63142 15.5175 6.89425 15.1299C7.15708 14.742 7.53592 14.4039 8.03075 14.1156C8.52558 13.8271 9.11025 13.6108 9.78475 13.4666C10.4591 13.3223 11.1962 13.2501 11.9963 13.2501C12.8116 13.2501 13.5564 13.3223 14.2308 13.4666C14.9051 13.6108 15.4897 13.8271 15.9845 14.1156C16.4795 14.4039 16.8558 14.742 17.1135 15.1299C17.3712 15.5175 17.5 15.9454 17.5 16.4136V17.7886H6.5ZM19.1923 17.7886V16.3781C19.1923 16.0019 19.1477 15.6474 19.0588 15.3146C18.9696 14.9819 18.8359 14.6681 18.6578 14.3731C18.8539 14.3398 19.0414 14.3174 19.2203 14.3059C19.3991 14.2944 19.5757 14.2886 19.75 14.2886C20.8667 14.2886 21.7708 14.4999 22.4625 14.9224C23.1542 15.3447 23.5 15.8937 23.5 16.5694V17.7886H19.1923ZM8.077 16.2886H15.9385V16.1829C15.836 15.779 15.4103 15.4393 14.6615 15.1636C13.9128 14.8879 13.0257 14.7501 12 14.7501C10.9743 14.7501 10.0872 14.8879 9.3385 15.1636C8.58967 15.4393 8.16917 15.779 8.077 16.1829V16.2886ZM4.257 13.3174C3.78567 13.3174 3.383 13.1498 3.049 12.8146C2.715 12.4794 2.548 12.0765 2.548 11.6059C2.548 11.129 2.71567 10.7262 3.051 10.3974C3.38617 10.0685 3.78908 9.90411 4.25975 9.90411C4.73658 9.90411 5.141 10.0685 5.473 10.3974C5.80517 10.7262 5.97125 11.13 5.97125 11.6089C5.97125 12.0735 5.80692 12.4744 5.47825 12.8116C5.14975 13.1488 4.74267 13.3174 4.257 13.3174ZM19.75 13.3174C19.2833 13.3174 18.8814 13.1488 18.5443 12.8116C18.2071 12.4744 18.0385 12.0735 18.0385 11.6089C18.0385 11.13 18.2071 10.7262 18.5443 10.3974C18.8814 10.0685 19.2839 9.90411 19.7518 9.90411C20.2339 9.90411 20.6394 10.0685 20.9683 10.3974C21.2971 10.7262 21.4615 11.129 21.4615 11.6059C21.4615 12.0765 21.2975 12.4794 20.9695 12.8146C20.6415 13.1498 20.235 13.3174 19.75 13.3174ZM12.0035 12.5001C11.2832 12.5001 10.6698 12.2477 10.1635 11.7429C9.65717 11.2382 9.404 10.6253 9.404 9.90411C9.404 9.16844 9.65633 8.55186 10.161 8.05436C10.6658 7.55669 11.2788 7.30786 12 7.30786C12.7355 7.30786 13.3521 7.55636 13.8497 8.05336C14.3472 8.55019 14.596 9.16595 14.596 9.90061C14.596 10.6208 14.3476 11.2341 13.8508 11.7406C13.3538 12.2469 12.738 12.5001 12.0035 12.5001ZM12.0048 11.0001C12.3106 11.0001 12.5689 10.8931 12.7797 10.6791C12.9908 10.4649 13.0962 10.2049 13.0962 9.89911C13.0962 9.59345 12.9912 9.33511 12.781 9.12411C12.5708 8.91328 12.3105 8.80786 12 8.80786C11.6975 8.80786 11.4392 8.91294 11.225 9.12311C11.0108 9.33311 10.9038 9.59344 10.9038 9.90411C10.9038 10.2066 11.0108 10.4649 11.225 10.6791C11.4392 10.8931 11.6991 11.0001 12.0048 11.0001Z"
                                  fill="black"
                                />
                              </svg>

                              <p className="text-[12px] font-poppins m-0 p-0 font-[500]">
                                Equipes
                              </p>
                            </li>

                            <li className="flex items-center gap-2 space-x-2 font-semibold cursor-pointer font-poppins">
                              <svg
                                width="17"
                                height="19"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M2.30775 19.5C1.80258 19.5 1.375 19.325 1.025 18.975C0.675 18.625 0.5 18.1974 0.5 17.6923V4.30777C0.5 3.8026 0.675 3.37502 1.025 3.02502C1.375 2.67502 1.80258 2.50002 2.30775 2.50002H3.69225V0.384766H5.23075V2.50002H12.8077V0.384766H14.3077V2.50002H15.6923C16.1974 2.50002 16.625 2.67502 16.975 3.02502C17.325 3.37502 17.5 3.8026 17.5 4.30777V17.6923C17.5 18.1974 17.325 18.625 16.975 18.975C16.625 19.325 16.1974 19.5 15.6923 19.5H2.30775ZM2.30775 18H15.6923C15.7692 18 15.8398 17.9679 15.9038 17.9038C15.9679 17.8398 16 17.7693 16 17.6923V8.30777H2V17.6923C2 17.7693 2.03208 17.8398 2.09625 17.9038C2.16025 17.9679 2.23075 18 2.30775 18ZM2 6.80777H16V4.30777C16 4.23077 15.9679 4.16026 15.9038 4.09626C15.8398 4.0321 15.7692 4.00002 15.6923 4.00002H2.30775C2.23075 4.00002 2.16025 4.0321 2.09625 4.09626C2.03208 4.16026 2 4.23077 2 4.30777V6.80777ZM9 12.077C8.75517 12.077 8.5465 11.9908 8.374 11.8183C8.20167 11.6459 8.1155 11.4373 8.1155 11.1923C8.1155 10.9474 8.20167 10.7388 8.374 10.5663C8.5465 10.3939 8.75517 10.3078 9 10.3078C9.24483 10.3078 9.4535 10.3939 9.626 10.5663C9.79833 10.7388 9.8845 10.9474 9.8845 11.1923C9.8845 11.4373 9.79833 11.6459 9.626 11.8183C9.4535 11.9908 9.24483 12.077 9 12.077ZM5 12.077C4.75517 12.077 4.5465 11.9908 4.374 11.8183C4.20167 11.6459 4.1155 11.4373 4.1155 11.1923C4.1155 10.9474 4.20167 10.7388 4.374 10.5663C4.5465 10.3939 4.75517 10.3078 5 10.3078C5.24483 10.3078 5.4535 10.3939 5.626 10.5663C5.79833 10.7388 5.8845 10.9474 5.8845 11.1923C5.8845 11.4373 5.79833 11.6459 5.626 11.8183C5.4535 11.9908 5.24483 12.077 5 12.077ZM13 12.077C12.7552 12.077 12.5465 11.9908 12.374 11.8183C12.2017 11.6459 12.1155 11.4373 12.1155 11.1923C12.1155 10.9474 12.2017 10.7388 12.374 10.5663C12.5465 10.3939 12.7552 10.3078 13 10.3078C13.2448 10.3078 13.4535 10.3939 13.626 10.5663C13.7983 10.7388 13.8845 10.9474 13.8845 11.1923C13.8845 11.4373 13.7983 11.6459 13.626 11.8183C13.4535 11.9908 13.2448 12.077 13 12.077ZM9 16C8.75517 16 8.5465 15.9138 8.374 15.7413C8.20167 15.5689 8.1155 15.3603 8.1155 15.1155C8.1155 14.8705 8.20167 14.6618 8.374 14.4895C8.5465 14.317 8.75517 14.2308 9 14.2308C9.24483 14.2308 9.4535 14.317 9.626 14.4895C9.79833 14.6618 9.8845 14.8705 9.8845 15.1155C9.8845 15.3603 9.79833 15.5689 9.626 15.7413C9.4535 15.9138 9.24483 16 9 16ZM5 16C4.75517 16 4.5465 15.9138 4.374 15.7413C4.20167 15.5689 4.1155 15.3603 4.1155 15.1155C4.1155 14.8705 4.20167 14.6618 4.374 14.4895C4.5465 14.317 4.75517 14.2308 5 14.2308C5.24483 14.2308 5.4535 14.317 5.626 14.4895C5.79833 14.6618 5.8845 14.8705 5.8845 15.1155C5.8845 15.3603 5.79833 15.5689 5.626 15.7413C5.4535 15.9138 5.24483 16 5 16ZM13 16C12.7552 16 12.5465 15.9138 12.374 15.7413C12.2017 15.5689 12.1155 15.3603 12.1155 15.1155C12.1155 14.8705 12.2017 14.6618 12.374 14.4895C12.5465 14.317 12.7552 14.2308 13 14.2308C13.2448 14.2308 13.4535 14.317 13.626 14.4895C13.7983 14.6618 13.8845 14.8705 13.8845 15.1155C13.8845 15.3603 13.7983 15.5689 13.626 15.7413C13.4535 15.9138 13.2448 16 13 16Z"
                                  fill="black"
                                />
                              </svg>

                              <p className="text-[12px] font-poppins m-0 p-0 font-[500]">
                                Périodes
                              </p>
                            </li> */}

                            {/* <li className="flex items-center gap-2 space-x-2 font-semibold cursor-pointer font-poppins">
                              <svg
                                width="19"
                                height="19"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 15C12.8333 15 13.5417 14.7083 14.125 14.125C14.7083 13.5417 15 12.8333 15 12C15 11.1667 14.7083 10.4583 14.125 9.875C13.5417 9.29167 12.8333 9 12 9C11.1667 9 10.4583 9.29167 9.875 9.875C9.29167 10.4583 9 11.1667 9 12C9 12.8333 9.29167 13.5417 9.875 14.125C10.4583 14.7083 11.1667 15 12 15ZM12 16.5C10.7513 16.5 9.68917 16.0622 8.8135 15.1865C7.93783 14.3108 7.5 13.2487 7.5 12C7.5 10.7513 7.93783 9.68917 8.8135 8.8135C9.68917 7.93783 10.7513 7.5 12 7.5C13.2487 7.5 14.3108 7.93783 15.1865 8.8135C16.0622 9.68917 16.5 10.7513 16.5 12C16.5 13.2487 16.0622 14.3108 15.1865 15.1865C14.3108 16.0622 13.2487 16.5 12 16.5ZM5 12.75H1.25V11.25H5V12.75ZM22.75 12.75H19V11.25H22.75V12.75ZM11.25 5V1.25H12.75V5H11.25ZM11.25 22.75V19H12.75V22.75H11.25ZM6.573 7.577L4.23075 5.3155L5.2905 4.20575L7.54625 6.523L6.573 7.577ZM18.7095 19.7943L16.4385 17.4615L17.427 16.423L19.7693 18.6845L18.7095 19.7943ZM16.423 6.573L18.6845 4.23075L19.7943 5.2905L17.477 7.54625L16.423 6.573ZM4.20575 18.7095L6.5385 16.4385L7.55775 17.427L5.30575 19.7788L4.20575 18.7095Z"
                                  fill="black"
                                />
                              </svg>

                              <p className="text-[12px] font-poppins m-0 p-0 font-[500]">
                                Thèmes
                              </p>
                            </li> */}
                            <Link to="/settings" title="Primes" target="_self">
                              <li className="flex items-center gap-2 mt-2 space-x-2 font-semibold cursor-pointer font-poppins">
                                <Cog className="w-5 h-5" color="black" />

                                <p className="text-[12px] font-poppins m-0 p-0 font-[500]">
                                  Paramètres
                                </p>
                              </li>
                            </Link>
                            <Link to="/" title="Primes" target="_self">
                              <li
                                className="flex items-center gap-2 space-x-2 font-semibold cursor-pointer font-poppins"
                                onClick={() => {
                                  localStorage.removeItem("data");
                                  localStorage.removeItem("token");
                                  localStorage.removeItem("idworkspace");
                                  window.location.replace("/");
                                }}
                              >
                                <svg
                                  width="19"
                                  height="19"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H12.0095V5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H12.0095V20.5H5.30775ZM16.2308 16.2692L15.1923 15.1845L17.627 12.75H9.09625V11.25H17.627L15.1923 8.8155L16.2308 7.73075L20.5 12L16.2308 16.2692Z"
                                    fill="black"
                                  />
                                </svg>

                                <p className="text-[12px] font-poppins m-0 p-0 font-[500]">
                                  Se déconnecter
                                </p>
                              </li>
                            </Link>
                          </ul>
                        </div>
                        {/* <ul>
                          <li>
                            <Link
                              to="/profile"
                              href="#"
                              className="mui-popover-item"
                              onClick={() => {
                                sessionStorage.removeItem("data");
                              }}
                            >
                              Mon compte
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/"
                              href="#"
                              className="mui-popover-item"
                              onClick={() => {
                                localStorage.removeItem("data");
                              }}
                            >
                              Me déconnecter
                            </Link>
                          </li>
                        </ul> */}
                      </div>
                    </Popover>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
